<template>
	<div>
		<v-dialog
			v-model="showDPDialog"
			fullscreen
			persistent
			transition="dialog-bottom-transition"
		>
			<v-card class="dp-vcard">
				<v-toolbar class="dp-toolbar" dark color="primary">
					<v-toolbar-title>{{getStateWithParam('dp_modal_title')}}</v-toolbar-title>
				</v-toolbar>
				<v-card-text>
					<div class="subheading font-weight-black" style="margin: 0 0 15px;">{{getStateWithParam('language_title')}}</div>
					<LanguageSettings class="lang-settings" />
					<v-divider></v-divider>
					<div class="subheading font-weight-black" style="margin: 20px 0 15px;">{{getStateWithParam('accept_dp_title')}}</div>
					<p v-html="getStateWithParam('accept_dp_text')"></p>
					<p><a @click="toggleConditionsDialog"><strong>{{getStateWithParam('terms_modal_link_label')}}</strong></a></p>
					<p><a @click="togglePrivacyDialog"><strong>{{getStateWithParam('privacy_modal_link_label')}}</strong></a></p>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-btn class="accept-btn" color="primary" text block @click="setAccepteDP">{{getStateWithParam('accept_dp_btn')}}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import native_capacitor from "@/config/js_helper/native_capacitor";
import { TERMS_CONDITIONS_URL, PRIVACY_POLICY_URL } from "@/config/api/url/urls_in_app";
import LanguageSettings from "@/components/cards/LanguageSettings";
export default {
	data(){
		return {
			showConditionsDialog: false,
			showPrivacyDialog: false,
		}
	},
	components: {
		LanguageSettings
	},
	computed: {
		showDPDialog(){
			return this.$root.showDPDialog
		},
		terms_conditions_url(){
			let type_language = this.$store.state.type_language
			return TERMS_CONDITIONS_URL[type_language]
		},
		privacy_policy_url(){
			let type_language = this.$store.state.type_language
			return PRIVACY_POLICY_URL[type_language]
		},
		lang: {
			get(){
				console.log(this.$store.state.type_language)
				return this.$store.state.type_language
			},
			set(langval){
				console.log(langval)
				if (typeof langval != 'undefined') {
					this.$store.commit('setNewLanguageType', langval)
				}
			}
		}
	},
	methods: {
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},
		setAccepteDP(){
			this.$root.setAccepteDP()
		},
		toggleConditionsDialog(){
			native_capacitor.openUrl(this.terms_conditions_url)
			//this.showConditionsDialog = !this.showConditionsDialog
		},
		togglePrivacyDialog(){
			native_capacitor.openUrl(this.privacy_policy_url)
			//this.showPrivacyDialog = !this.showPrivacyDialog
		}
	}
}
</script>
<style lang="scss" scoped>
.dp-toolbar{
	padding-top: var(--top) !important;
}
.dp-vcard{
	padding-bottom: var(--bottom) !important;
	display: flex;
	flex-direction: column;
	height: 100%;
	.v-card__text{
		flex-grow: 1;
		overflow: auto;
	}
	.accept-btn{ color: white !important; }
}
.lang-settings{
	margin-bottom: 20px;
}
</style>